/**
 * CurrentSeasonInProgressGate
 */
import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Components
import SeasonInProgressGate from '../SeasonInProgressGate';

// Selectors
import { selectCurrentSeasonId } from '../../services/currentSeasonId/selectors';

interface Props {
    children: React.Node;
    currentSeasonId?: number;
    Fallback?: number;
}

export class CurrentSeasonInProgressGate extends React.PureComponent<Props> {
    render() {
        const { children, currentSeasonId, Fallback } = this.props;
        return (
            <SeasonInProgressGate
                seasonId={currentSeasonId}
                Fallback={Fallback}
            >
                {children}
            </SeasonInProgressGate>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    currentSeasonId: selectCurrentSeasonId
});

export default connect(mapStateToProps)(CurrentSeasonInProgressGate);
